<template>
    <div>
        <div class="spacer-40"></div>
        <div class="part-line"></div>
        <div class="main-title">Your PlayRipple RegNo</div>
        <div class="spacer-40"></div>
        <div class="component" style="position:relative;">
            <table class="normal-tb">
                <thead>
                <tr>
                    <th>RegNo</th>
                    <th>User ID</th>
                    <th>Investment</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="income in list" :key="income.rownum">
                    <!--<td :class="{my_playxrp_row : income.its_me === '1'}">#{{income.mem_level}}</td>-->
                    <td :class="{my_playxrp_row : income.its_me === '1'}" >{{income.ref_disp}}</td>
                    <td :class="{my_playxrp_row : income.its_me === '1'}" >
                        <div v-if="income.its_me === '1'">{{income.mem_uuid}}</div>
                        <a href="" onclick="avascript: return false;" v-on:click="showPersonDetail(income.mem_uuid)" v-else>{{income.mem_uuid}}</a>
                    </td>
                    <td :class="{my_playxrp_row : income.its_me === '1'}">{{income.xrp_income_amt}} XRP</td>
                </tr>
                </tbody>
            </table>
        </div>
        <modal :show.sync="modals.personal"
               modal-classes="modal-detail modal-dialog-centered ">
            <p>User ID : {{ this.mem_uuid }}</p>
            <div class="spacer-10"></div>
            <div class="body-normal">
                <div class="pop-id-box">
                    <div class="pop-id-box-in">
                        <div>
                            Total Package Income<br/>
                            Amount<br/>
                            {{this.personDetail.total_deposit}} XRP
                        </div>
                    </div>
                    <div class="pop-id-box-in">
                        <div>
                            Withdrawal<br/>
                            Amount<br/>
                            {{this.personDetail.total_withdrawal}} XRP
                        </div>
                    </div>
                    <div class="pop-id-box-in">
                        <div>
                            Reinvestment<br/>
                            Amount<br/>
                            {{this.personDetail.reinvestment_amount}} XRP
                        </div>
                    </div>
                    <div class="pop-id-box-in">
                        <div>
                            Referral<br/>
                            Amount<br/>
                            {{this.personDetail.total_referral}} XRP
                        </div>
                    </div>
                    <div class="pop-id-box-in">
                        <div>
                            Upline<br/>
                            Amount<br/>
                            {{this.personDetail.upline_income}} XRP
                        </div>
                    </div>
                    <div class="pop-id-box-in">
                        <div>
                            Downline<br/>
                            Amount<br/>
                            {{this.personDetail.downline_income}} XRP
                        </div>
                    </div>
                    <div class="pop-id-box-in">
                        <div>
                            Withdrawable<br/>
                            Amount<br/>
                            {{this.personDetail.total_balance}} XRP
                        </div>
                    </div>
                    <!--<div class="pop-id-box-in">
                        <div>
                            Registration NO<br/>
                            #{{this.personDetail.mem_level}}
                        </div>
                    </div>-->
                </div>
            </div>
            <template v-slot:footer>
                <base-button
                        type="link"
                        text-color="white"
                        class="ml-auto"
                        @click="modals.personal = false"
                >Close</base-button>
            </template>
        </modal>
    </div>
</template>
<style>
    .my_playxrp_row {
        background-color: #1B2B69 !important;
        color: white !important;
    }
    .modal-detail p {
        font-size: 16px;
        font-weight: bold;
        color: #fff;
    }
</style>
<script>
import Modal from "@/components/Modal.vue";
import axios from "../../service/axios";
import {mapGetters} from "vuex";

export default {
    data: () =>{
        return {
            mem_uuid : '',
            personDetail : {},
            list: {},
            modals: {
                personal: false,
            },
        }
    },
    components: {
        Modal
    },
    computed: {
        ...mapGetters(["isAuthenticated"]), /* store에 저장된 값을 가져온다. */
    },
    methods: {
        getSafeFloat : function(value) {
            let strVal = value + '';
            strVal = strVal.replace(/,/g, '');
            return Number.parseFloat(strVal);
        },
        showPersonDetail : function (mem_uuid) {
            if (this.isLoading === true) {
                return;
            }
            this.mem_uuid = mem_uuid;
            this.isLoading = true;
            const data = {
                person_id : mem_uuid,
            };
            if (this.isAuthenticated) {
                // JWT-Token Expired check
                axios
                    .post("/auth/v1/verifyToken")
                    .then(response => {
                    })
                    .catch(error => {
                        console.log(error)
                    });
                axios
                    .post("/users/v1/user/detail", data)
                    .then(response => {
                        this.personDetail = response.data;
                        //console.log(this.personDetail);
                        this.modals.personal = true;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log(error.response)
                        this.notificationMessage = 'Fail to get detail information.';
                        this.modals.notificationShow = true;
                        this.isLoading = false;
                    });
            }
        },
    },
    watch: {
        '$store.state.isAuthenticated': function() {
            // state에서 상태변화를 모니터링 한다.
            if (!this.isAuthenticated) {
                // 로그아웃으로 변화했다.
                this.list = {}
            }
            /*
            // 위의것도 가능하고 아래것도 가능하다. 그냥 위의 것을 사용한다.
            if (!this.$store.state.isAuthenticated) {
                // 로그아웃으로 변화했다.
                this.list = {}
            }
            */
        }
    },
    mounted() {
        if (!this.isAuthenticated) {
            this.list = {}
            return;
        }
        // JWT-Token Expired check
        axios
            .post("/auth/v1/verifyToken")
            .then(response => {})
            .catch(error => {
                console.log(error)
            });
        axios
            .post("/users/v1/my/playxrp/list")
            .then(response => {
                if (response.status === 200) {
                    this.list = response.data;
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
};
</script>
<style>
</style>
